import React from 'react';
import { methodology } from '../data/content';

const Methodology = () => {
  return (
    <section
      id="methodologie"
      className="py-16 md:py-24"
      style={{ backgroundColor: '#E9DFCF' }}
      data-testid="methodology-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <div className="flex items-baseline gap-3 mb-4 flex-wrap">
            <h2
              className="text-3xl md:text-4xl font-extrabold tracking-tight text-gray-900"
              style={{ letterSpacing: '-0.04em' }}
            >
              Notre méthodologie
            </h2>
            <span className="text-sm text-gray-500 font-medium">
              (exemple pour offre excellence sur devis)
            </span>
          </div>
          <p className="text-lg text-gray-600">
            Un processus éprouvé en 5 étapes pour garantir le succès de votre transformation, 
            adapté à votre rythme et vos contraintes.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Center line - hidden on mobile */}
          <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-0.5 h-full bg-gray-200" />

          <div className="space-y-8 md:space-y-0">
            {methodology.map((step, index) => {
              const isLeft = index % 2 === 0;
              
              return (
                <div
                  key={index}
                  className="relative md:flex md:items-center"
                  data-testid={`methodology-step-${index}`}
                >
                  {/* Mobile: Simple card layout */}
                  <div className="md:hidden">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-blue-700 rounded-full flex items-center justify-center text-white font-bold flex-shrink-0" style={{ backgroundColor: '#1C2E4A' }}>
                        {step.step}
                      </div>
                      <div className="flex-1 bg-white p-6 rounded-xl border border-gray-200">
                        <div className="flex items-center justify-between mb-2">
                          <h3 className="font-bold text-gray-900">{step.title}</h3>
                          <span className="text-sm text-blue-700 font-medium">{step.duration}</span>
                        </div>
                        <p className="text-sm text-gray-600">{step.description}</p>
                      </div>
                    </div>
                  </div>

                  {/* Desktop: Alternating layout */}
                  <div className="hidden md:flex md:w-full md:items-center" style={{ minHeight: '120px' }}>
                    {/* Left content */}
                    <div className={`w-5/12 ${isLeft ? 'pr-8 text-right' : ''}`}>
                      {isLeft && (
                        <div className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow inline-block text-left">
                          <div className="flex items-center justify-between mb-2">
                            <h3 className="font-bold text-gray-900">{step.title}</h3>
                            <span className="text-sm text-blue-700 font-medium ml-4">{step.duration}</span>
                          </div>
                          <p className="text-sm text-gray-600">{step.description}</p>
                        </div>
                      )}
                    </div>

                    {/* Center dot */}
                    <div className="w-2/12 flex justify-center">
                      <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold shadow-lg z-10" style={{ backgroundColor: '#1C2E4A' }}>
                        {step.step}
                      </div>
                    </div>

                    {/* Right content */}
                    <div className={`w-5/12 ${!isLeft ? 'pl-8' : ''}`}>
                      {!isLeft && (
                        <div className="bg-white p-6 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow inline-block">
                          <div className="flex items-center justify-between mb-2">
                            <h3 className="font-bold text-gray-900">{step.title}</h3>
                            <span className="text-sm text-blue-700 font-medium ml-4">{step.duration}</span>
                          </div>
                          <p className="text-sm text-gray-600">{step.description}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a
            href="#formulaire"
            className="inline-flex items-center justify-center text-white font-semibold py-4 px-8 rounded-full shadow-sm hover:shadow-md transition-all hover:-translate-y-0.5 active:scale-[0.98]"
            style={{ backgroundColor: '#1C2E4A' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#0F1E33'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#1C2E4A'}
            data-testid="methodology-cta"
          >
            Démarrer mon projet
          </a>
        </div>
      </div>
    </section>
  );
};

export default Methodology;
